import React from 'react';

export const NotFoundPage = () => (<div className="container-fluid">
	<div className="row m-t-10">
		<div className="col-md-12">
			<div className="alert alert-danger">404 Not Found</div>
		</div>
	</div>
</div>)
